import { Factory, Gear, Package, Sliders } from '@phosphor-icons/react'
import { ROLES } from '@/auth/roles'
import type { ConsoleDetailRoute, ConsoleSection } from '../routes'
import { BatchDetailPage } from '../pages/process/BatchDetailPage'
import { BatchesPage } from '../pages/process/BatchesPage'
import { MachinesPage } from '../pages/process/MachinesPage'
import { RunDetailPage } from '../pages/process/RunDetailPage'
import { RunsPage } from '../pages/process/RunsPage'
import { YieldBandsPage } from '../pages/process/YieldBandsPage'

const OFFICE = [ROLES.SUPERVISOR, ROLES.CENTRAL_ADMIN]

/** Sidebar entries for this area (in sidebar order). */
export const PROCESS_SECTIONS: ConsoleSection[] = [
  { path: 'runs', label: 'Machine runs', icon: Gear, group: 'Process', element: <RunsPage /> },
  { path: 'yield-bands', label: 'Yield bands', icon: Sliders, group: 'Process', element: <YieldBandsPage />, roles: OFFICE },
  { path: 'machines', label: 'Machines', icon: Factory, group: 'Process', element: <MachinesPage />, roles: OFFICE },
  { path: 'batches', label: 'Batches', icon: Package, group: 'Process', element: <BatchesPage /> },
]

/** Detail pages for this area: routed, not in the sidebar. */
export const PROCESS_DETAIL_ROUTES: ConsoleDetailRoute[] = [
  { path: 'runs/:id', element: <RunDetailPage /> },
  { path: 'batches/:id', element: <BatchDetailPage /> },
]
